export default __webpack_public_path__ + "media/projects/blue3-thumb-2457203c.svg";